package com.castly.admin.ui.components

import androidx.compose.runtime.*
import com.castly.admin.ui.theme.AppTheme
import com.castly.admin.ui.theme.BorderRadius
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun IconButton(
    icon: @Composable () -> Unit,
    label: String,
    onClick: () -> Unit,
    color: String? = null,
    hoverColor: String? = null,
    size: Int = 18
) {
    val colors = AppTheme.colors
    val iconColor = color ?: colors.textMuted
    val iconHoverColor = hoverColor ?: colors.text

    Tooltip(text = label) {
        Button({
            onClick { onClick() }
            attr("aria-label", label)
            attr("tabindex", "0")
            style {
                background("none")
                border(0.px)
                cursor("pointer")
                padding(6.px)
                borderRadius(BorderRadius.md)
                color(Color(iconColor))
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                justifyContent(JustifyContent.Center)
                property("transition", "background-color 0.2s ease, color 0.2s ease")
            }
            onMouseOver { evt ->
                (evt.target as? org.w3c.dom.HTMLElement)?.let {
                    it.style.backgroundColor = colors.surfaceHover
                    it.style.color = iconHoverColor
                }
            }
            onMouseOut { evt ->
                (evt.target as? org.w3c.dom.HTMLElement)?.let {
                    it.style.backgroundColor = "transparent"
                    it.style.color = iconColor
                }
            }
        }) {
            icon()
        }
    }
}
